import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import config from '../config'

const httpLink = new HttpLink({
  uri: `${config.api.serverUrl}/public_graphql`,
})

export const publicApolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      errorPolicy: 'all',
    },
  },
})
